<template>
  <!-- 住宿 -->
  <div>
    <div class="hotleInfo">
      <div class="rowA" v-show="deviceId == 1">
        <div class="english">STAR HOTEL</div>
        <div class="chinese">星级酒店</div>
      </div>
      <div class="rowA" v-show="deviceId == 2">
        <div class="english">ECONOMY HOTEL</div>
        <div class="chinese">经济酒店</div>
      </div>
      <div class="rowA" v-show="deviceId == 3">
        <div class="english">CHARACTERISTIC B&B</div>
        <div class="chinese">特色民宿</div>
      </div>
      <div style="display:flex;flex-direction: row-reverse;" v-if="info.isUrl" class="book_btn">
        <div class="card_btn" @click="handleOpen(info.outUrl)">预订</div>
      </div>
      <div class="rowB">
        <div class="body">
          <div class="hotelBody">
            <img :src="info.url" class="hotelImage" v-if="info.url != null" />
            <img src="@/assets/image/hotel.png" class="hotelImage" v-else />
          </div>
          <div style="display:flex;flex-direction:column;margin-left:39px">
            <div style="display: flex;flex-direction: row;justify-content: center;font-size: 1.296vh;font-family: 'Microsoft YaHei'; font-weight: 400;  color: #005a51;text-align: center;">
              <span>阅读次数: {{info.hits}}</span>
            </div>
            <div class="topTitle">{{ info.title }}</div>
            <div class="littleTitle" style="margin-top:18px">联系电话：{{ info.phone }}</div>
            <div class="littleTitle">酒店地址：{{ info.address }}</div>
            <div class="topTitleSec">酒店介绍</div>
            <div class="leftBody">
              <div v-html="info.details" class="leftBodyFont"></div>
            </div>
          </div>
        </div>
      </div>
       <!-- //返回 -->
      <div class="public-back-btn">
        <img src="@/assets/image/videoback.png" style="width:5vh;height:5vh;cursor:pointer;" @click="handleBack" />
      </div>
      <div class="rowC">
        <div class="layout">
          <div style="writing-mode:vertical-rl;display:flex;flex-direction:row">
            <div style="margin-top:1.018vh;">武夷山景区</div>
            <div style="margin-top:1.018vh;">天下难寻</div>
            <div style="margin-top:1.018vh;">Wuyi</div>
            <div>Mountain</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => { }
    },
  },
  data() {
    return {

    };
  },
  computed: {
    deviceId() {
      return this.$store.state.tabPage;
    }
  },
  methods: {
    handleOpen(e) {
      window.open(e);
    },
     handleBack() {
      this.$emit('closed');
    }
  }
};
</script>

<style scoped>
.hotleInfo {
  height: 85.555vh;
  background: url(../../assets/image/logoBottom.png) no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: row;
}
.hotleInfo .rowA {
  display: flex;
  flex-direction: row;
  margin-top: 6%;
  margin-left: 9.67%;
}
.card_btn {
  width: 63px;
  height: 20px;
  background: #ffffff;
  border-radius: 4px;
  font-weight: 400;
  font-size: 12px;
  color: #449088;
  text-align: center;
  line-height: 20px;
  cursor: pointer;
}
.hotleInfo .rowB {
  width: 100%;
  margin-top: 14.72vh;
  margin-left: 4.635vw;
  position: relative;
  display: flex;
  flex-direction: column;
  animation: bounceInRight 2s;
}

.hotleInfo .rowB .body {
  display: flex;
  flex-direction: row;
}
.hotleInfo .rowB .body .line {
  width: 100%;
  height: 0px;
  border-top: 0.09259vh dashed #449088;
  opacity: 0.5;
  margin-top: 1.4814vh;
}

.hotleInfo .rowB .body .hotelImage {
  min-width: 23.28125vw;
  height: 53.981vh;
  transition: all 0.6s;
}
.hotleInfo .rowB .body .hotelImage:hover {
  min-width: 23.28125vw;
  height: 53.981vh;
  transform: scale(1.4);
}
.hotleInfo .rowB .body .hotelBody {
  min-width: 23.28125vw;
  height: 53.981vh;
  overflow: hidden;
  cursor: pointer;
}

.hotleInfo .rowB .body .topTitle {
  line-height: 1.85185vh;
  font-size: 1.85185vh;
  font-family: "Microsoft YaHei";
  font-weight: bold;
  color: #005a51;
  margin-top: 1.6667vh;
}

.hotleInfo .rowB .body .littleTitle {
  font-size: 1.296vh;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #666666;
  margin-top: 0.9259vh;
}
.hotleInfo .rowB .body .topTitleSec {
  font-size: 1.296vh;
  margin-top: 4.9074vh;
  line-height: 1.4814vh;
  font-size: 1.4814vh;
  font-weight: bold;
  color: #005a51;
}

.hotleInfo .rowB .body .leftBody {
  margin-top: 1.8518vh;
  width: 100%;
  height: 32.77vh;
  overflow-y: scroll;
  font-size: 1.2962vh;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #666666;
  text-indent: 2em;
}
.hotleInfo .rowB .body .leftBody .leftBodyFont {
  width: 95%;
  line-height: 30px;
}

.hotleInfo .rowC {
  padding: 0px 0.3645vw 0px 0.3645vw;
  height: 26.481vh;
  line-height: 1.574vh;
  background: #d87001;
  color: #ffffff;
  margin-top: 2.6851vh;
  margin-left: 6.8%;
  margin-right: 1.04167vw;
  animation: bounceInTop 2s;
  font-size: 1.2962vh;
}
.hotleInfo .rowB .topFont {
  font-size: 1.66667vh;
  font-family: "Microsoft YaHei";
  font-weight: bold;
  color: #333333;
  line-height: 1.66667vh;
  margin-bottom: 1.388vh;
}
.hotleInfo .chinese {
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #c45b0e;
  writing-mode: vertical-rl;
  margin-left: 0.833vh;
  width: 0.833vw;
  font-size: 0.833vw;
  font-weight: bold;
  color: #d87001;
}
.hotleInfo .english {
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #c45b0e;
  writing-mode: vertical-rl;
  width: 0.833vw;
  font-size: 0.833vw;
  font-weight: bold;
  color: #d87001;
}
.leftBody::-webkit-scrollbar {
  width: 4px;
  /*height: 4px;*/
}
/* 滑块 */
.leftBody::-webkit-scrollbar-thumb {
  border-radius: 4px;
  /* -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2); */
  background: #ababab;
}
/* 滑槽 */
.leftBody::-webkit-scrollbar-track {
  /* -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2); */
  border-radius: 4px;
}
.book_btn {
  position: absolute;
  z-index: 11;
  right: 6%;
  top: 10%;
}
</style>



// WEBPACK FOOTER //
// src/views/hotel/detailsInfo.vue